import { apiClient } from './api';
import type { TenantAthleteProgressResponse, TenantDirectoryOverviewResponse } from '../types';

export async function getTenantDirectoryOverview(): Promise<TenantDirectoryOverviewResponse> {
  const response = await apiClient.get<TenantDirectoryOverviewResponse>('/api/v1/web/tenant-directory/overview');
  return response.data;
}

export async function getTenantAthleteProgress(athleteId: number): Promise<TenantAthleteProgressResponse> {
  const response = await apiClient.get<TenantAthleteProgressResponse>(
    `/api/v1/web/tenant-directory/athletes/${athleteId}/progress`
  );
  return response.data;
}
